import React from 'react';
import Icon from '@/components/ui/Icon';

const PrimaryImageIcon = () => (
  <div className="tw-bg-tci-purple tw-h-3 tw-w-3 tw-p-1 tw-rounded-md tw-inline-flex tw-justify-center tw-items-center">
    <Icon fill="white" icon="Crown" size={14} />
  </div>
);

export default PrimaryImageIcon;
